import type { Directive } from 'vue'
const SCOPE = '_RepeatClick'
export interface RepeatClickEl extends HTMLElement {
  [SCOPE]: null | {
    start?: (evt: MouseEvent) => void
  }
}
export interface RepeatClickOptions {
  immediate?: boolean
  delay?: number
  handler: (...args: unknown[]) => unknown
}
const vRepeatClick: Directive<RepeatClickEl, RepeatClickOptions> & {
  name: string
} = {
  name: 'repeatClick',
  // 在绑定元素的 attribute 前
  // 或事件监听器应用前调用
  // created(el, binding, vnode) {
  //   // el.style.display = 'none'
  //   // 下面会介绍各个参数的细节
  //   console.log('created', el, binding, vnode)
  // },

  // 在元素被插入到 DOM 前调用
  beforeMount(el, binding) {
    const { delay = 300, immediate } =
      typeof binding.value === 'object' ? binding.value : {}
    const handler =
      typeof binding.value === 'object' ? binding.value.handler : binding.value
    let isPending = false
    let timer: ReturnType<typeof setTimeout>
    const start = (e: MouseEvent) => {
      if (e.button !== 0) return // 只处理左键点击
      timer && clearTimeout(timer)
      timer = setTimeout(() => {
        if (immediate) {
          isPending = false
        } else {
          handler?.(e)
        }
      }, delay)
      if (immediate) {
        if (isPending) {
          return
        }
        isPending = true
        handler?.(e)
      }
    }
    el[SCOPE] = { start }
    el.addEventListener('click', start)
  },
  //   // 在绑定元素的父组件
  //   // 及他自己的所有子节点都挂载完成后调用
  //   mounted(el, binding, vnode) {
  //     console.log('mounted', el, binding, vnode)
  //   },
  //   // 绑定元素的父组件更新前调用
  //   beforeUpdate(el, binding, vnode, prevVnode) {
  //     console.log('beforeUpdate', el, binding, vnode, prevVnode)
  //   },
  //   // 在绑定元素的父组件
  //   // 及他自己的所有子节点都更新后调用
  //   updated(el, binding, vnode, prevVnode) {
  //     console.log('updated', el, binding, vnode, prevVnode)
  //   },
  //   // 绑定元素的父组件卸载前调用
  //   beforeUnmount(el, binding, vnode) {
  //     console.log('beforeUnmount', el, binding, vnode)
  //   },
  // 绑定元素的父组件卸载后调用
  unmounted(el) {
    if (!el[SCOPE]) return
    const { start } = el[SCOPE]

    if (start) {
      el.removeEventListener('mousedown', start)
    }
    el[SCOPE] = null
  },
}
export default vRepeatClick
